import { IOrder } from '../../lib/ssp/types';

import { PER_PAGE } from './constants';

export function paginateOrders(orders: IOrder[], perPage: number) {
  if (orders.length > perPage - 1) {
    return orders.slice(0, perPage);
  }

  return orders;
}

export function calculateShowMoreCount(listSize: number, inView: number) {
  if (listSize - inView >= PER_PAGE) {
    return PER_PAGE;
  }
  return listSize - inView;
}
